module.exports = __webpack_public_path__ + "img/expired.48941136.png";